<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item>课程管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button
      type="primary"
      size="mini"
      class="add-btn"
      @click="goToAdd"
    >新增课程
    </el-button>
    <el-table
      class="table"
      ref="table"
      :data="courseList"
      style="width: 100%">
      <el-table-column
        prop="courseId"
        label="课程ID"
        align="center"
        width="80">
      </el-table-column>
      <el-table-column
        prop="pic"
        label="课程图片"
        align="center">
        <template scope="scope">
          <img :src="scope.row.pic" width="60" height="60"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="typeDesc"
        label="类型"
        align="center">
      </el-table-column>
      <el-table-column
        prop="levelDesc"
        label="等级"
        align="center">
      </el-table-column>
      <el-table-column
        prop="name"
        label="课程名称"
        align="center"
        width="200">
      </el-table-column>
      <el-table-column
        prop="nameEnglish"
        label="课程英文名称"
        align="center"
        width="300">
      </el-table-column>
      <el-table-column
        prop="price"
        label="价格(￥)"
        align="center">
      </el-table-column>
      <el-table-column
        prop="detail"
        label="课程详情"
        align="center"
        width="450">
      </el-table-column>
      <el-table-column
        prop="statusDesc"
        label="状态"
        align="center">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
          >修改
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script type="text/ecmascript-6">
  import { listType } from '../common/js/config';
  import { getCourseList } from '../api/course';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'course_list',
    created() {
      let pageNum = this.$route.params.pageNum;
      this._getCourseList();
    },
    methods: {
      goToAdd(item = {}) {
        this.setItem({
          item,
          type: listType.COURSE
        });
        this.$router.push('/add_course');
      },
      handleEdit(index, item) {
        this.setItem({
          item,
          type: listType.COURSE
        });
        this.$router.push({
          path: `/update_course/${item.uuid}`
        });
      },
      _getCourseList() {
        getCourseList(this.user.userId).then((res) => {
          this.setList({
            list: res.courses,
            type: listType.COURSE
          });
        });
      },
      ...mapActions([
        'setList',
        'setItem'
      ])
    },
    computed: {
      ...mapGetters([
        'courseList',
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    height: 100%;
    overflow: scroll;
    .title
      margin-bottom: 20px;
    .add-btn
      margin-bottom: 10px;
    .table
    .pagination
      margin-top: 10px;
</style>